import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import styled from "styled-components";
import Article from "./Article";

const Wrapper = styled.div`
  background-color: ${props => props.background ? `${props.background}` : ' #eaeaea' };  
`

const Container = styled.div`
  width: 930px;
  padding: 23px 0 24px 0;
  margin: 0 auto;

  // Mobile version.
  @media (max-width: 768px) {
    padding: 23px 16px 24px 16px;
    width: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  h2 {
    font-family: Lato-Light;
    font-size: 24px;
    color: #2b2b2b;
    line-height: 28px;
    margin: 0;
  }
  ul {
    padding: 0;
    list-style-type: none;
    height: auto;

    > li {
      margin: 0;
      padding: 0;
    }
  }

  > div.faq-container {
    background: white;
  }
`;
export class HelpfulInformation extends Component {

  render() {
    const { t } = this.props;
    const articles = this.props.articles
    const hasArticles = articles.length > 0

    if(!hasArticles) {
      return null
    }

    return (
      <Wrapper>
        <Container background={this.props.background}>
          <section className="helpful-information-container" aria-labelledby="helpfulInformationHeading">
            <h2 id="helpfulInformationHeading">{t("HelpfulInformation.Title")}</h2>
            <ul>
              {articles.map(function(el, index) {
                return (
                  <li key={`Article_${index}`}>
                    <Article
                      title={el.title}
                      description={el.description}
                      body={el.body}
                      video_url={el.video_url}
                      hr_source_cd={el.hr_source_cd}
                    />
                  </li>
                );
              })}
            </ul>
          </section>
        </Container>
      </Wrapper>
    );
  }
}

export default withTranslation('translations')(HelpfulInformation);
